<template>
  <div>
    <TServFilterHouseComp :compProps="{fromDate: fromDate, toDate: toDate}" :payLoad="payLoad" :compIndex="''" @finish="finishHandle"></TServFilterHouseComp>
  </div>
</template>
<script>
/* eslint-disable */
import TServFilterHouseComp from './TServFilterHouseComp'
import { fetchSearchLableMapping } from '@/services/filterTab'
import { fetchHouse, fetchFavirote, fetchHouseWithFilter } from '@/services/house'
import { format, formatText } from '@/utils/q_business'
import { convertPinyin } from '@/utils/convertPinyin'
import { eventBus } from '@/utils'

const ONE_DAY = 1000 * 60 * 60 * 24 // 一天的时间戳

export default {
  components: {
    TServFilterHouseComp
  },
  data() {
    return {
      labelStrategyMappings: [],
      cityList: [],
      curCity: {},
      curFilter: {},
      themeFilters: [],
      labelKeys: [],
      fromDate: '',
      toDate: ''
    }
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    payLoad(newVal) {
      const actionType = newVal.type
      switch(actionType) {
        case 'changeCity':
          this.changeCity(newVal.newCity)
          break
        case 'changeFilter':
          this.changeFilter(newVal.newFilter)
          break
        case 'changeSubFilter':
          this.changeSubFilter(newVal.newSubFilters)
          break
        case 'loadMore':
          this.loadMore(newVal.data);
          break
        // 子servComp组件处理的变更事件，可以不用监听
        case 'openHouseInfo':
          break
        case 'favoriteHouse':
          break
        default:
      }
    }
  },
  methods: {
    async init() {
      // TODO: 在二级筛选项中加入运营配置的选中样式相关数据
      // 获取城市和二三级筛选项映射关系
      const labelStrategyId = this.compProps.mate.filterId
      const labelRes = await fetchSearchLableMapping({ labelStrategyId, wrapperId: 'waptujia004' })
      
      if (labelRes.ret && labelRes.data) {
        // TODO: 功能完善 活动页加载时可能包含默认选中的筛选项、城市等
        const query = this.$route.query;
        const queryCityId = parseInt(query.cityId) || ''
        const queryLabelKey = query.labelkey_2
        const querySubLabelKey = query.labelkey_3
        
        const { labelStrategyMappings } = labelRes.data
        this.labelStrategyMappings = labelStrategyMappings

        // url中有城市id，优先使用url中的城市；url没有，采用映射规则的第一个城市
        let curLabelStrategyCityMapping
        labelStrategyMappings.forEach((labelStrategyCityMapping) => {
          if (labelStrategyCityMapping.cityId === queryCityId) {
            curLabelStrategyCityMapping = labelStrategyCityMapping
          }
        })
        if (curLabelStrategyCityMapping === undefined) {
          curLabelStrategyCityMapping = labelStrategyMappings[0]
        }
        const curCityId = curLabelStrategyCityMapping.cityId
        const curCityName = curLabelStrategyCityMapping.cityName
        const curCity = { cityId: curCityId, cityName: curCityName }
        this.curCity = curCity
        // 当前城市下可选的二级筛选项，需要把b端配置的样式信息添加进去
        const keyIndexMap = {}
        const themeFilters = curLabelStrategyCityMapping.cityLabelList
          .map((labelStrategyMapping, index) => {
            const { labelKey, labelName, level, childList } = labelStrategyMapping
            keyIndexMap[labelKey] = index
            return { labelKey, labelName, level, childList }
          })
        this.compProps.mate.items.forEach((item) => {
          const styleProperties = {
            pageBackground: item.pageBackground,
            selectColor: item.selectColor,
            textColor: item.textColor
          } 
          themeFilters[keyIndexMap[item.labelKey]] = {
            ...themeFilters[keyIndexMap[item.labelKey]],
            ...styleProperties
          }
        })
        this.themeFilters = themeFilters
       
        // url有筛选项参数，优先作为默认选中筛选项; url没有，采用第一个作为默认选中
        let curFilter
        let curSubFilters = []  
        themeFilters.forEach((filter) => {
          if (filter.labelKey === queryLabelKey) {
            curFilter = filter
          }
        })
        if (curFilter === undefined) {
          curFilter = themeFilters[0]
        } 
        this.curFilter = curFilter
        const subFilters = curFilter.childList
        if (querySubLabelKey) {
          curFilter.childList.forEach((subFilter) => {
            if (subFilter.labelKey === querySubLabelKey) {
              curSubFilters.push(subFilter)
            }
          })
        }
        
        const cityList = this.cityList = this.getCityList(labelStrategyMappings)

        let filters = {
          curCity,
          curFilter,
          curSubFilters,
          cityList,
          themeFilters,
          subFilters
        }
        this.$emit('init', { type: 'initFilter', data: filters})

        let labelKeys = []
        labelKeys.push(curFilter.labelKey)
        curSubFilters.forEach((subFilter) => {
          labelKeys.push(subFilter.labelKey)
        })
        this.labelKeys = labelKeys
        this.refreshHouses(curCityId, labelKeys);
      }
    },
    // 根据城市筛选项的映射关系，生成可以选择的城市列表数据
    getCityList(mappings) {
      // 首字母及所属分组的城市
      const letters = {};
      // 按字母表排序后的城市数据
      const cityList = [];
      mappings.forEach((city) => {
        const { cityId, cityName } = city;
        const pinYin = convertPinyin(cityName);
        const firstLetter = pinYin[0].toUpperCase();
        // 首字母不存在就新建分组，存在就插入数据
        if (letters[firstLetter]) {
          letters[firstLetter].items.push({
            cityId,
             name: cityName
          })
        } else {
          letters[firstLetter] = {
            name: firstLetter,
            items: [{
              cityId,
              name: cityName
            }]
          }
        }
      })
      // 按字母表顺序生成嵌套数组
      const beginCharCode = 'A'.charCodeAt(0);
      const endCharCode = 'Z'.charCodeAt(0);
      for (let index = beginCharCode; index <= endCharCode; index++) {
        const letter = String.fromCharCode(index);
        if (letters[letter]) {
          cityList.push(letters[letter]);
        }
      }

      return cityList;
    },
    // 切换城市
    async changeCity(newCity) {
      // 清空已选中筛选项，更新当前城市映射的二三级筛选项
      // 设置筛选项默认值
      
      const labelStrategyMappings = this.labelStrategyMappings;
      const curLabelStrategyCityMapping = labelStrategyMappings.filter((cityMapping) => {
        return cityMapping.cityId === newCity.cityId
      })[0];
      const curCityId = curLabelStrategyCityMapping.cityId
      const curCityName = curLabelStrategyCityMapping.cityName
      const curCity = { cityId: curCityId, cityName: curCityName }
      this.curCity = curCity;
      // 当前城市的二级筛选项
      const keyIndexMap = {}
      const themeFilters = curLabelStrategyCityMapping.cityLabelList
          .map((labelStrategyMapping, index) => {
            const { labelKey, labelName, level, childList } = labelStrategyMapping
            keyIndexMap[labelKey] = index
            return { labelKey, labelName, level, childList }
          })
      this.compProps.mate.items.forEach((item) => {
        const styleProperties = {
          pageBackground: item.pageBackground,
          selectColor: item.selectColor,
          textColor: item.textColor
        } 
        themeFilters[keyIndexMap[item.labelKey]] = {
          ...themeFilters[keyIndexMap[item.labelKey]],
          ...styleProperties
        }
      })
      this.themeFilters = themeFilters

      const curFilter = themeFilters[0]
      this.curFilter = curFilter
      const subFilters = curFilter.childList
      const cityList = this.cityList
      const filters = {
        curCity,
        curFilter,
        curSubFilters: [],
        cityList,
        themeFilters,
        subFilters
      }
      eventBus.$emit('filter_change', curFilter)
      this.$emit('finish', { type: 'updateFilter', data: filters});

      let labelKeys = [];
      labelKeys.push(curFilter.labelKey);
      this.labelKeys = labelKeys;
      this.refreshHouses(curCityId, labelKeys);
    },
    // 改变二级筛选项
    changeFilter(newFilter) {
      eventBus.$emit('filter_change', newFilter)
      const { curCity, cityList, themeFilters } = this;
      const labelStrategyMappings = this.labelStrategyMappings;
      const curLabelStrategyCityMapping = labelStrategyMappings.filter((cityMapping) => {
        return cityMapping.cityId === curCity.cityId
      })[0];
      const curFilter = themeFilters.filter((label) => {
        return label.labelKey === newFilter.labelKey
      })[0]
      this.curFilter = curFilter
      const subFilters = curFilter.childList
    
      const filters = {
        curCity,
        curFilter,
        curSubFilters: [],
        cityList,
        themeFilters,
        subFilters
      }
      this.$emit('finish', { type: 'updateFilter', data: filters});

      let labelKeys = [];
      labelKeys.push(curFilter.labelKey);
      this.labelKeys = labelKeys;
      this.refreshHouses(curCity.cityId, labelKeys);
    },
    // 改变选中的三级筛选项
    changeSubFilter(newSubFilters) {
      const { curCity, curFilter, cityList, themeFilters } = this;
      const labelStrategyMappings = this.labelStrategyMappings;
      const curLabelStrategyCityMapping = labelStrategyMappings.filter((cityMapping) => {
        return cityMapping.cityId === curCity.cityId
      })[0];
      const subFilters = curFilter.childList
    
      const filters = {
        curCity,
        curFilter,
        curSubFilters: newSubFilters,
        cityList,
        themeFilters,
        subFilters
      }
      this.$emit('finish', { type: 'updateFilter', data: filters})
      // labelKeys代表选中的二三级筛选项集合
      let labelKeys = []
      labelKeys.push(curFilter.labelKey)
      newSubFilters.forEach((subFilter) => {
        labelKeys.push(subFilter.labelKey)
      })
      this.labelKeys = labelKeys
      this.refreshHouses(curCity.cityId, labelKeys)
    },
     // 加载更多房屋
    loadMore(data) {
      const { curCity, labelKeys } = this
      const { pageIndex } = data
      this.refreshHouses(curCity.cityId, labelKeys, pageIndex)
    },
    // 刷新房屋数据
    async refreshHouses(cityId, labelKeys = [], pageIndex = 1) {
      const { privateProps } = this.compProps.mate
      
      // 入离店日期优先取url中的入离日期（app传入）
      const query = this.$route.query
      const date = new Date()
      let fromDate
      let toDate
      if (query.fromDate && query.toDate) {
        fromDate = format('yyyy-MM-dd', new Date(query.fromDate))
        toDate = format('yyyy-MM-dd', new Date(query.toDate))
      } else {
        fromDate = format('yyyy-MM-dd', date)
        toDate = format('yyyy-MM-dd', new Date(date.getTime() + ONE_DAY))
      }
      this.fromDate = fromDate
      this.toDate = toDate

      let params = {
        checkInDate: this.fromDate,
        checkOutDate: this.toDate,
        cityId: cityId,
        filters: labelKeys,
        topShowUnitIds: houseIds,
        pageIndex: pageIndex,
        pageSize: 30
      }
      const ret = await fetchHouseWithFilter(params)
      let faviroteRet = null
      let faviroteIds = []
      const maxShowNumber = +this.compProps.mate.maxShowNumber
      let total = 0
        let items = []
        if (ret.errcode === 0 && ret.data) {
          total = ret.data.totalCount
          items = ret.data.items || []
        }

        if (total > +maxShowNumber) {
          total = +maxShowNumber
          items = items.splice(0, total)
        }
        let hasPriceTags = false
        let hasSpecialTags = false
        let houseIds = items.map((item) => {
          return item.unitId
        }) || [];
        if (this.$root.promotionId !== 'T20190108142924' && this.$root.promotionId !== 'T20190118154654') {
          faviroteRet = await fetchFavirote(houseIds)
        }

        if (faviroteRet && faviroteRet.errcode === 0) {
          faviroteIds = faviroteRet.data.houseIdList
        }
        items = items && items.map((item) => {
          let house = item
          if (this.compProps.houseChoice === '0') {
            house = this.compProps.houses.find((itemHouse) => {
              return itemHouse.id + '' === item.unitId + ''
            })
          }
          const favirote = faviroteIds.find((faviroteId) => {
            return faviroteId === item.unitId
          })
          let priceTags = item.priceTags || []
          if (this.compProps.mode === '2') {
            priceTags = item.priceTags && item.priceTags.splice(0, 1)
          }
          if (priceTags && priceTags.length > 0) {
            hasPriceTags = true
          }
          let specialTags = item.specialTags || []
          if (specialTags.length > 0) {
            hasSpecialTags = true
          }
          return {
            ...item,
            priceTags,
            comment: house.comment,
            isLike: favirote !== undefined
          }
        })
        items = items && items.map((item) => {
          return {
            ...item,
            hasPriceTags,
            hasSpecialTags,
            pictureList: item.pictureList
          }
        })
        const data = {
          totalCount: total,
          items: items
        }
      if (pageIndex === 1) {
        this.$emit('init', {
          type: 'initHouse',
          data: {
            totalCount: total,
            items: items,
            pageIndex,
            maxShowNumber,
            pageSize: 30
          }
        })
      } else {
        this.$emit('finish', {
          type: 'loadMoreHouses',
          data: {
            totalCount: total,
            items: items,
            pageIndex,
            maxShowNumber: parseInt(maxShowNumber),
            pageSize: 30
          }
        })
      }
    },
    // 透传子servComp组件finish事件到UiComp组件
    finishHandle(payLoad) {
      this.$emit('finish', payLoad);
    }
  }
}
</script>
